import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './SelectUser.css';


function SelectUser() {

    const navigate = useNavigate();

    //gives the user the appropriate links to direct them to the proper page 
    return (
        <div className="container">
            <h1>Hello! Welcome to the ELC!</h1>

            <div className="box">
                <h2>Please select</h2>
                <div className="link-container">
                    <Link to="/bm" className="link">Admin</Link>
                    <Link to="/studenthome" className="link">Student</Link>
                </div>
            </div>
        </div>
    )

}



export default SelectUser;